
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { take } from 'rxjs/operators';

// ngrx store
import { Store } from '@ngrx/store';
// models
import { AppState } from '../../booking/models/app-state.interface';
import { UserAgentInitState } from '../models/user-agent.interface';
// globals
import { GET_USER_IP } from '../../shared/globals';

// Assuming you have your package.json file in the assets folder
import packageJson from '../../../../package.json';
declare var System: any;

@Injectable({
  providedIn: 'root',
})
export class UserAgentService {

  private userData: UserAgentInitState = {
    ip: null,
    userAgentString: null,
    appVersion: null,
    dateTimeLocal: null,
    bookingRef: null
  };

  constructor (
    private _appStore: Store<AppState>,
    private _http: HttpClient
  ) {}

  storeUserAgentData() {

    const currentState = this.getState(this._appStore).userAgentReducer;

    if (currentState.userAgentString !== null) { return; }

    // only get data if not already in store...
    this.userData.userAgentString = window.navigator.userAgent;
    this.userData.dateTimeLocal = new Date().toString();

    this._http
      .get(GET_USER_IP)
      .subscribe(
        (res:any) => {

          // const result = res;
           const result = res;
          this.userData.ip = result.ip;

            this.userData.appVersion = packageJson.version;
            this._appStore.dispatch({ type: 'UPDATE_USER_AGENT_DATA', payload: this.userData });

      });
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
    .subscribe(s => state = s);
    return state;
  }

}
